// extracted by mini-css-extract-plugin
export default {"description":"style_description__rJsch","fade-in":"style_fade-in__o-ymb","top":"style_top__EO7+1","image":"style_image__AR2wP"};